// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2icAk","colMin":"styles_colMin__1LdML"};